import { createFileRoute } from "@tanstack/react-router";
import { CheckDisposalView } from "../../app/views/lineCheck/checkDisposalView";

export const Route = createFileRoute("/disposal/check")({
  component: CheckDisposalView,
});
